import { render, staticRenderFns } from "./s-card-with-toolbar.vue?vue&type=template&id=0058ca0a&scoped=true"
import script from "./s-card-with-toolbar.vue?vue&type=script&lang=js"
export * from "./s-card-with-toolbar.vue?vue&type=script&lang=js"
import style0 from "./s-card-with-toolbar.vue?vue&type=style&index=0&id=0058ca0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0058ca0a",
  null
  
)

export default component.exports